customElements.get('product-card-2022') ||
    customElements.define('product-card-2022', class extends HTMLElement {
        get title() {
            return this.getAttribute('title');
        }
        get id() {
            return this.getAttribute('id');
        }
        get productId() {
            return this.getAttribute('productId');
        }
        get image() {
            return this.getAttribute('image');
        }
        get price() {
            return this.getAttribute('price');
        }
        get url() {
            return this.getAttribute('url');
        }
        get tags() {
            return this.getAttribute('tags');
        }
        get available() {
            return this.getAttribute('available');
        }
        static get observedAttributes() {
            return ['id', 'tags', 'title', 'image', 'price', 'url', 'available'];
        }
        constructor() {
            super();
            let template = document.getElementById('product-card-2022-template');
            let templateContent = template.content;
            let elementContent = templateContent.cloneNode(true);
            this.div = document.createElement('div');
            this.div.className = 'tailwind';
            this.div.append(elementContent);
        }
        connectedCallback() {
            this.render();
        }
        attributeChangedCallback(prop, oldVal, newVal) {
            this.render();
        }
        render() {
            const container = window.document.querySelectorAll(`product-card-2022[id="${this.id}"]`);
            if (container.length > 0) {
                container[0].innerHTML = '';
            }
            this.div.querySelectorAll('.product-card-2022')[0].id = this.id;
            let separator = '.jpg';
            if (this.image.indexOf(separator) === -1) {
                separator = '.png';
            }
            const imageURL = this.image.split(separator);
            // @ts-ignore
            this.div.querySelectorAll('#product-card-2022-image')[0].src =
                imageURL[0] + '_x400' + separator + imageURL[1];
            const titleSplitted = this.title.split('-');
            this.div.querySelectorAll('#product-card-2022-title1')[0].innerHTML =
                titleSplitted[0].trim().slice(0, 35);
            if (titleSplitted.length > 1) {
                this.div.querySelectorAll('#product-card-2022-title2')[0].innerHTML =
                    titleSplitted[1].trim();
            }
            this.div.querySelectorAll('#product-card-2022-price')[0].innerHTML =
                '$' + this.price;
            this.div.querySelectorAll('#product-card-2022-ratings')[0].dataset.bvProductId = this.productId;
            this.div.querySelectorAll('#product-card-2022-ratings')[0].dataset.bvRedirectUrl = this.url;
            this.div
                .querySelectorAll('#product-card-2022-new-label')[0]
                .classList.add('hidden');
            this.div
                .querySelectorAll('#product-card-2022-bestseller-label')[0]
                .classList.add('hidden');
            if (!!this.tags) {
                if (this.tags.indexOf('NEW') > -1) {
                    this.div
                        .querySelectorAll('#product-card-2022-new-label')[0]
                        .classList.remove('hidden');
                }
                else if (this.tags.indexOf('Bestseller') > -1) {
                    this.div
                        .querySelectorAll('#product-card-2022-bestseller-label')[0]
                        .classList.remove('hidden');
                }
            }
            const ctaLabel = this.div.querySelector('.cta-label');
            const ctaLink = this.div.querySelector('.cta-link');
            ctaLabel.classList.remove('cta-default');
            ctaLabel.classList.add('cta-disabled');
            ctaLabel.innerHTML = 'Sold Out';
            ctaLink.removeAttribute('href');
            if (this.available === 'true') {
                ctaLink.href = this.url;
                ctaLabel.classList.remove('cta-disabled');
                ctaLabel.classList.add('cta-default');
                ctaLabel.innerHTML = 'Shop Now';
            }
            if (container.length > 0) {
                container[0].append(this.div);
            }
        }
    });
